module.exports = __webpack_public_path__ + "static/media/card-placeholder_918.8f647065.svg";